// 🔧 promotion_status.js
// ✅ Purpose: Central workflow status definitions for the LGV Promotion Engine
// ✅ Features:
// - Defines independent lifecycle state machines
// - Prevents one generic "status" field from becoming overloaded
// - Supports future workflow automation
// - Designed for MVP 2 expansion
// - Fully block-commented for clarity and future devs

/**
 * ============================================================================
 * IDEA STATUS
 * ============================================================================
 *
 * Tracks the lifecycle of an idea before it becomes a post.
 */

export const PROMOTION_IDEA_STATUS = {
  NEW: "new",
  READY_FOR_AI: "ready_for_ai",
  CONVERTED_TO_QUEUE: "converted_to_queue",
  ARCHIVED: "archived",
};

/**
 * ============================================================================
 * QUEUE STATUS
 * ============================================================================
 *
 * Tracks the editorial workflow.
 */

export const PROMOTION_QUEUE_STATUS = {
  DRAFT: "draft",
  NEEDS_REVIEW: "needs_review",
  APPROVED: "approved",
  REJECTED: "rejected",
  ARCHIVED: "archived",
  PUBLISHED: "published",
};

/**
 * ============================================================================
 * IMAGE STATUS
 * ============================================================================
 *
 * Tracks AI image generation.
 */

export const PROMOTION_IMAGE_STATUS = {
  NONE: "none",
  GENERATED: "generated",
  SELECTED: "selected",
  REPLACED: "replaced",
};

/**
 * ============================================================================
 * PUBLISH STATUS
 * ============================================================================
 *
 * Tracks publishing lifecycle.
 */

export const PROMOTION_PUBLISH_STATUS = {
  NOT_READY: "not_ready",
  SCHEDULED: "scheduled",
  POSTING: "posting",
  POSTED: "posted",
  PUBLISHED: "published",
  FAILED: "failed",
};

/**
 * ============================================================================
 * FOLLOW STATUS
 * ============================================================================
 *
 * Tracks Prospect follow targets.
 */

export const PROMOTION_FOLLOW_STATUS = {
  NOT_REVIEWED: "not_reviewed",
  FOLLOWED: "followed",
  SKIPPED: "skipped",
};

/**
 * ============================================================================
 * CAMPAIGN STATUS
 * ============================================================================
 *
 * Reserved for MVP 2 campaign workflows.
 */

export const PROMOTION_CAMPAIGN_STATUS = {
  DRAFT: "draft",
  ACTIVE: "active",
  PAUSED: "paused",
  COMPLETED: "completed",
  ARCHIVED: "archived",
};
